<template>
  <AgencyContactDetailsComponent
      v-if="agencyId"
      :id="agencyId"
  />
  <p class="m-0" v-else>Onbekend</p>
</template>

<script>
export default {
  name: "AgencyCell",
  props: {
    cellProps: {
      type: Object,
    },
    row: {
      type: Object,
    }
  },
  computed:{
    agencyId(){
      return this.cellProps?.data?.id;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>